import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { unixFromNow, isImageExt } from '../../../utils'

const state = {
  list: []
}

const actions = {
  [aTypes.CONTACT_GET_CONTACT_ATTACHMENTS] ({ commit }, id) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_ATTACHMENTS, loading: true })
    api.contact.getContactAttachment({
      success (res) {
        const data = res.body
        const list = data.map(item => {
          return {
            key: {
              text: item.name
            },
            href: item.path,
            value: unixFromNow(item.create_time),
            image: isImageExt(item.ext) ? item.path : null
          }
        })
        commit(mTypes.CONTACT_SET_CONTACT_ATTACHMENTS, list)
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_ATTACHMENTS, loading: false })
      },
      commit
    }, id)
  }
}

const mutations = {
  [mTypes.CONTACT_SET_CONTACT_ATTACHMENTS] (state, list) {
    state.list = list
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/attachment.js